// extracted by mini-css-extract-plugin
export var attribution = "_b4-4";
export var authorName = "_b4-5";
export var quote = "_b4-3";
export var testimonial = "_b4-2";
export var trustedBy = "_b4-0";
export var trustedByLabel = "_b4-1";